var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteBLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H27.9671C39.2717 0 46.9284 3.69276 46.9284 14.8476C46.9284 20.7215 44.0215 24.8161 38.8537 27.3417C46.0925 29.4464 49.7403 35.0525 49.7403 42.5145C49.7403 54.6643 39.4997 59.8686 28.765 59.8686H0V0ZM13.0716 24.223H26.2951C30.874 24.223 34.2749 22.1183 34.2749 17.1053C34.2749 11.4035 29.943 10.2364 25.2882 10.2364H13.0716V24.223ZM13.0716 49.6131H27.0551C32.2039 49.6131 36.7068 47.9293 36.7068 41.7301C36.7068 35.5308 32.8689 33.1774 27.3021 33.1774H13.0716V49.6131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBLogo);
export default __webpack_public_path__ + "static/media/white_b_logo.7a7b47b3a047a27bb733e8bf6213a99b.svg";
export { ForwardRef as ReactComponent };